import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output } from '@angular/core';
import { ChangeCause } from '../../change-cause';
import { FieldType } from '../../field-type';
import { FormFieldSettings } from '../../forms/form-field/data/form-field-settings';
import { FormFieldState } from '../../forms/form-field/data/form-field-state';
import { FilterFieldState } from './data/filter-field-state';

@Component({
  selector: 'app-filter-field',
  templateUrl: './filter-field.component.html',
  styleUrls: ['./filter-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterFieldComponent implements OnInit {
  @Input() width: string;

  @Input() set type(value: FieldType){
      this._type = value;
  };
  get type() {
    return this._type;
  }
  private _type: FieldType = FieldType.STRING; //tipo di default
  @Input() equalLabel: string;
  @Input() fromLabel: string;
  @Input() toLabel: string;

  @Input() set settings(options: FormFieldSettings){
    this._settings = options
  }
  get settings(){ return this._settings }
  private _settings: FormFieldSettings

  @Output() modelChange: EventEmitter<FilterFieldState> = new EventEmitter<FilterFieldState>();

  get value() {
    return this._value
  }
  protected _value?: any;
  //WARNING: Da usare SOLO per settare il valore dall'esterno
  @Input() set value(value: any){
    if(value) {
      this._valueForInput = JSON.parse(JSON.stringify(value))
    }else
      this._valueForInput = null;
  }
  get valueForInput() {
    return this._valueForInput
  }
  protected _valueForInput?: any;

  set editMode(editMode: boolean){
    this._editMode = editMode
    // if(!this._betweenFilter)
    //   this.equal.editMode = editMode     //TODO: per settare focus da fuori
    // else
    //   this.from.editMode = editMode      //TODO: per settare focus da fuori
  }
  get editMode() {
    return this._editMode
  }
  protected _editMode?: boolean;      //true se il campo ha il focus ed è quindi in fase di modifica. Può essere passato a true per settare il focus di default su quel field
  
  constructor(
    private zone: NgZone,
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  // Da usare per effettuare inizializzazioni indipendenti dall'input del componente
  ngOnInit() {
    //console.log('!!!!!!filter-field onInit');
    this._value = {mode: 'equal', equal: null, from: null, to: null} //TODO
  }

  toggleMode = () => {
    console.log(`lifecycle - FilterFieldComponent.toggleMode()`);

    this._value.mode = this._value.mode == 'equal' ? 'between' : 'equal'
    this.modelChange.emit(this._prepareOutput(ChangeCause.FILTER_MODE_CHANGE))
  }

  onEqualFilterChange = (out: FormFieldState) => {
    console.log(`lifecycle - FilterFieldComponent.onEqualFilterChange()`);
    let value: any = this._value ? JSON.parse(JSON.stringify(this._value)) : {}
    value.equal = out.value
    this._value = value
    this._editMode = out.editMode;

    this.modelChange.emit(this._prepareOutput(out.changeCause))
  }

  onFromFilterChange = (out: FormFieldState) => {
    console.log(`lifecycle - FilterFieldComponent.onFromFilterChange()`);
    let value: any = this._value ? JSON.parse(JSON.stringify(this._value)) : {}
    value.from = out.value
    this._value = value

    // L'elemento "from" è successivo ad "equal" nel DOM (onFromFilterChange() viene chiamato dopo onEqualFilterChange())
    // Questa assegnazione deve tenere conto di un eventuale precedente settaggio a true
    this._editMode = this._editMode || out.editMode;

    this.modelChange.emit(this._prepareOutput(out.changeCause))
  }

  onToFilterChange = (out: FormFieldState) => {
    console.log(`lifecycle - FilterFieldComponent.onToFilterChange()`);
    let value: any = this._value ? JSON.parse(JSON.stringify(this._value)) : {}
    value.to = out.value
    this._value = value

    // L'elemento "to" è successivo ad "equal" e "from" nel DOM (onToFilterChange() viene chiamato dopo onEqualFilterChange() e onFromFilterChange())
    // Questa assegnazione deve tenere conto di un eventuale precedente settaggio a true
    this._editMode = this._editMode || out.editMode;

    this.modelChange.emit(this._prepareOutput(out.changeCause))
  }

  /**
  * Prepara una nuova istanza di FilterField da inviare al parent tramite emit()
  */
  _prepareOutput = (changeCause?: ChangeCause): FilterFieldState => {
    return {
      value: this._value,
      editMode: this._editMode,
      changeCause: changeCause
    } as FilterFieldState
  }
}
